import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(BASE_URL);

class PMAService {
  static registerApplication = data => api.post(urls.WORKFLOW.REGISTER_APPLICATION, data);

  static submitWorkflow = (data, url) => api.post(url, data);

  static uploadDocument = (body, params) => api.post(urls.DOCUMENT.UPLOAD_DOCUMENT, body, params);

  static uploadDocumentComplete = body => api.post(urls.DOCUMENT.DOCUMENT_COMPLETE, body);

  static fetchDocuments = data => api.get(urls.DOCUMENT.FETCH_DOCUMENTS, null, data);

  static downloadDocuments = data => api.get(urls.DOCUMENT.DOWNLOAD_DOCUMENT, null, data);

  static fetchApplication = id => api.get(urls.PMA.APPLICATION_DETAILS, id);

  static fetchApplicationDetail = id => api.get(urls.WORKFLOW.FETCH_APPLICATION, id);

  static fetchCompanyDetails = id => api.get(urls.OWNER.FETCH_COMPANY_BY_LICENSE, id);

  static savePMAApplication = data => api.post(urls.PMA.SAVE_PMA_APPLICATION, data);

  static checkoutPMAApplication = data => api.post(urls.PMA.CHECKOUT_PMA_APPLICATION + '/' + data);

  static cancelApplication = (id, params = { status: 'DISCARD' }) =>
    api.post(urls.WORKFLOW.CANCEL_APPLICATION, null, params, id);

  static fetchPmaBuilidings = (id, parms = { page: 0, size: 5 }) => api.get(urls.PMA.BUILDINGS, id, parms);

  static fetchPmaUnits = data => api.post(urls.PMA.UNITS, data);

  static validatePMAProperties = data => api.post(urls.PMA.VALIDATE, data);

  static addPMAProperties = (data, isOverride) => api.post(urls.PMA.ADD_PROPERTIES + '?isOverride=' + isOverride, data);

  static removePMAProperties = data => api.deleteWithBody(urls.PMA.DELETE_PROPERTIES, null, data);

  static getPMAProperties = (data, pageInfo) => api.get(urls.PMA.GET_BUILDINGS_BY_PAGE, data, pageInfo);

  static getPMAUnits = data => api.post(urls.PMA.GET_UNITS_BY_PAGE, data);

  // ownerACtion final approval
  static pmaApplicationActionOwner = data => api.post(urls.PMA.OWNER_APPROVAL, data);

  // other owner
  static pmaApplicationActionOtherOwner = data => api.post(urls.PMA.OTHER_OWNER_APPROVAL, data);

  // bank
  static pmaApplicationBankApprovalAndReturn = data => api.post(urls.PMA.BANK_APPROVAL, data);

  static pmaTerminationApplicationBankApprovalAndReturn = data => api.post(urls.PMA.BANK_APPROVAL_TERMINATION, data);

  // parties
  static pmaApplicationActionParties = data => api.post(urls.PMA.PARTIES_APPROVAL, data);

  static getApplicationPDFApp = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.PMA.APPLICATION_PDF, appId);
  };

  static downloadApplicationContract = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.PMA.CONTRACT_PDF, appId);
  };

  static pmaCancellationInitiate = (id, params) => api.post(`${urls.PMA.PMA_CANCELLATION}/${id}`, null, params);

  static pmaCancellationPartyApproval = data => api.post(urls.PMA.CANCELLATION_PARTIES_APPROVAL, data);

  static pmaCancellationOwnerApproval = data => api.post(urls.PMA.CANCELLATION_OWNER_APPROVAL, data);

  static fetchBreakdown = id => api.get(`${urls.PMA.PAYMENT_BREAKDOWN}/${id}`);

  static rejectApplication = (id, params) => api.post(`${urls.PMA.REJECT_WITH_REASON}/${id}`, {}, params);
}

export default PMAService;
